import styled from '@emotion/styled';

export const ContentSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;
  align-items: center;
  flex: 1;
  gap: 24px;
`;

export const LogoWrapper = styled.div``;

export const Heading = styled.h1<{ isLight: boolean }>`
  font-family: Custora;
  font-weight: 400;
  font-style: Regular;
  font-size: 36px;
  leading-trim: NONE;
  line-height: 130%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #e9ecf5;
  margin: 0;
  padding: 0;
`;

export const SubHeading = styled.h1<{ isLight: boolean }>`
  font-family: Inter;
  font-weight: 400;
  font-style: Regular;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 140%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #b7bdcb;
  margin: 0;
  padding: 0;
`;

export const ClickableLogo = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const EmailButton = styled.button`
  all: unset;
  cursor: pointer;
  height: 48px;
  border-radius: 8px;
  background: #5e84ed;
  color: #ffffff;
  font-family: Inter;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 44.61px;
  letter-spacing: 0px;
  text-align: center;
  width: 100%;
`;
